import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { IconPlus, IconApplicationAccountPlus } from '@sfx/icons';
import { Button } from 'reactstrap';
import UserManagementTable from './userTable.component';
import { SearchInput } from '../../../Basic/Input';
import useUsers from './hooks/useUsers';
import useModal from './hooks/useModal';
import { modalConfig } from './modals/common/modalConfig';
import { getModalContent } from './modals/common/getModalContent';
import { UserRequest } from './UserRequest';
import { ACCOUNT_ADMIN } from '../../utils/checkSFxRoleAuth';

var UserManagement = function UserManagement(props) {
  var _authUser$SFxRole;

  var prefix = props.prefix,
      translate = props.translate,
      authUser = props.authUser,
      hasUsersPrivilege = props.hasUsersPrivilege;

  var _useUsers = useUsers(),
      _useUsers2 = _slicedToArray(_useUsers, 6),
      userList = _useUsers2[0],
      total = _useUsers2[1],
      userListLoading = _useUsers2[2],
      userParams = _useUsers2[3],
      UpdateUserParams = _useUsers2[4],
      updateUsers = _useUsers2[5];

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedUser = _useState2[0],
      setSelectedUser = _useState2[1];

  var _useState3 = useState('add'),
      _useState4 = _slicedToArray(_useState3, 2),
      modalType = _useState4[0],
      setModalType = _useState4[1];

  var modalInstance = useRef();
  var handlerModalOk = useCallback(function () {
    var current = modalInstance.current;
    if (current && current.submit) current.submit();

    if (modalType === 'detail') {
      setModalType('edit');
    }
  }, [modalType]);
  var handlerModalRest = useCallback(function () {
    modalInstance.current.reset();
  }, []);

  var _useModal = useModal(handlerModalOk, handlerModalRest),
      _useModal2 = _slicedToArray(_useModal, 7),
      open = _useModal2[1],
      close = _useModal2[2],
      updateShowModalLoading = _useModal2[3],
      updateDisableOk = _useModal2[4],
      updateShowReset = _useModal2[5],
      renderModal = _useModal2[6];

  var openModal = useCallback(function (modalType, coverTitle) {
    var _modalConfig$modalTyp = modalConfig[modalType],
        title = _modalConfig$modalTyp.title,
        okText = _modalConfig$modalTyp.okText,
        isShowRest = _modalConfig$modalTyp.isShowRest,
        contentTitle = _modalConfig$modalTyp.contentTitle,
        disableOk = _modalConfig$modalTyp.disableOk;
    open({
      title: coverTitle ? coverTitle : translate(title),
      okText: translate(okText),
      contentTitle: translate(contentTitle),
      isShowRest: isShowRest,
      disableOk: disableOk
    });
  }, [open, translate]);
  var handleEditOrDetail = useCallback(function (_ref) {
    var modalType = _ref.modalType,
        selectedUser = _objectWithoutProperties(_ref, ["modalType"]);

    setSelectedUser(selectedUser);
    setModalType(modalType);

    if (modalType === 'edit') {
      var userName = selectedUser.userName;
      openModal(modalType, userName);
    } else {
      openModal(modalType);
    }
  }, [openModal]);

  var handleDel = function handleDel(selectedUser) {
    setSelectedUser(selectedUser);
    setModalType('delete');
    openModal('delete');
  };

  var handlerAddOrRequest = function handlerAddOrRequest() {
    var modalType = hasUsersPrivilege ? 'add' : 'request';
    setModalType(modalType);
    openModal(modalType);
  };

  useEffect(function () {
    if (modalType === 'edit') {
      var userName = selectedUser.userName;
      openModal(modalType, userName);
    }
  }, [modalType, openModal, selectedUser]);
  var onModalDataChange = useCallback(function (enableSubmit, enableReset) {
    updateDisableOk(!enableSubmit);
    if (enableReset !== undefined) updateShowReset(enableReset);
  }, [updateDisableOk, updateShowReset]);
  var getSaveModalRequestStatus = useCallback(function (loading, closeModal, updateUserList) {
    updateShowModalLoading(loading);

    if (updateUserList) {
      updateUsers();
    }

    if (closeModal) {
      close();
    }
  }, [close, updateShowModalLoading, updateUsers]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-wrap ").concat(prefix, "-content-user")
  }, /*#__PURE__*/React.createElement("div", {
    id: "Tips",
    className: "".concat(prefix, "-user-request-container")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-request-container")
  }, ((_authUser$SFxRole = authUser.SFxRole) === null || _authUser$SFxRole === void 0 ? void 0 : _authUser$SFxRole.includes(ACCOUNT_ADMIN)) && /*#__PURE__*/React.createElement(UserRequest, {
    translate: translate,
    prefix: prefix
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-wrap-option-handle ").concat(prefix, "-operation-area")
  }, /*#__PURE__*/React.createElement(SearchInput, {
    placeholder: translate('SFxAccountSettingsUserSearchInput'),
    onSearchClick: function onSearchClick(value) {
      return UpdateUserParams({
        terms: value,
        Index: 1
      });
    }
  }), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "sm",
    onClick: handlerAddOrRequest
  }, hasUsersPrivilege ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconPlus, {
    size: "18"
  }), "\xA0", translate('SFxAccountSettingsAddUserButtonText')) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconApplicationAccountPlus, {
    size: "18"
  }), " \xA0", translate('SFxAccountSettingsRequestUserButtonText')))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-content-wrap-table")
  }, /*#__PURE__*/React.createElement(UserManagementTable, {
    translate: translate,
    readOnly: !hasUsersPrivilege,
    authUser: authUser,
    pageIndex: Number(userParams.Index) - 1,
    userListData: userList,
    handleEditOrDetail: handleEditOrDetail,
    handleDel: handleDel,
    loading: userListLoading,
    total: total,
    onSortedChange: function onSortedChange(props) {
      var orderBy = props.orderId,
          orderDirection = props.orderDirection;
      UpdateUserParams({
        orderBy: orderBy,
        orderDirection: orderDirection
      });
    },
    onChange: function onChange(_ref2) {
      var Index = _ref2.pageIndex,
          Size = _ref2.pageSize,
          orderBy = _ref2.orderId,
          orderDirection = _ref2.orderDirection;
      Index++;
      UpdateUserParams({
        Index: Index,
        Size: Size,
        orderBy: orderBy,
        orderDirection: orderDirection
      });
    }
  })), renderModal({
    children: getModalContent(modalType, {
      selectedUser: selectedUser,
      translate: translate,
      prefix: prefix,
      onModalDataChange: onModalDataChange,
      ref: modalInstance,
      orgId: authUser.orgId,
      getHttpRequestStatus: getSaveModalRequestStatus
    })
  }));
};

export default UserManagement;